<template>
    <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.taxTypes.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyTaxTypesNew'})"
        >
          Nov tip davka
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.taxTypes.length">
      <v-col
        cols="12" lg="6"
        v-for="item of filteredTaxTypes" :key="item.id"
      >
        <TitleOnlyCard
          :title="`${item.type} - ${item.name}`"
          @edit="$router.push({name: 'MyCompanyTaxTypesEdit', params: {id: item.id}})"
          @delete="showDeleteTaxTypeModal = true; deleteTaxType = item"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje novega tipa davka uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje tipa davka"
      text="Ali ste prepričani, da želite izbrisati tip davka? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteTaxTypeModal"
      @confirmed="remove(deleteTaxType)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      filter: '',
      showDeleteTaxTypeModal: false,
      deleteTaxType: null
    }
  },
  computed: {
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    },
    filteredTaxTypes () {
      return this.taxTypes.filter(item => siIncludes({ haystack: item.name, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('taxTypes', ['loadItems', 'deleteItem']),
    remove (item) {
      deleteItem(item, this)
    }
  },
  created () {
    loadItems(this)
  }
}
</script>
